/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RequestListDtoFromJSON, RequestListDtoToJSON, } from './RequestListDto';
/**
 * Check if a given object implements the RequestListFolderDto interface.
 */
export function instanceOfRequestListFolderDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('requestLists' in value) || value['requestLists'] === undefined)
        return false;
    return true;
}
export function RequestListFolderDtoFromJSON(json) {
    return RequestListFolderDtoFromJSONTyped(json, false);
}
export function RequestListFolderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'requestLists': (json['requestLists'].map(RequestListDtoFromJSON)),
    };
}
export function RequestListFolderDtoToJSON(json) {
    return RequestListFolderDtoToJSONTyped(json, false);
}
export function RequestListFolderDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'requestLists': (value['requestLists'].map(RequestListDtoToJSON)),
    };
}
